import { AfterViewInit, Component, DestroyRef, ElementRef, inject, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { ButtonModule } from 'primeng/button';
import { UserService } from '../../services/user.service';
import { fromEvent } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-login',
  imports: [ButtonModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent implements AfterViewInit {
  // To handle restericted access flow
  protected forbidden = inject(Router).getCurrentNavigation()?.extras.state?.['forbidden'];

  @ViewChild('logo', { static: true }) logo!: ElementRef<HTMLImageElement>;

  private userService = inject(UserService);

  private readonly oidcSecurityService = inject(OidcSecurityService);
  private readonly router = inject(Router);
  private readonly destroyRef$ = inject(DestroyRef);

  private originalLogoSrc: string = '';

  configuration$ = this.oidcSecurityService.getConfiguration();

  userData$ = this.oidcSecurityService.userData$;

  isAuthenticated = false;

  ngOnInit(): void {
    this.oidcSecurityService.isAuthenticated$
      .pipe(takeUntilDestroyed(this.destroyRef$))
      .subscribe(({ isAuthenticated }) => {
        this.isAuthenticated = isAuthenticated;

        if (isAuthenticated) {
          this.router.navigate(['/']);
        }
      });

    fromEvent(window, 'pageshow')
      .pipe(takeUntilDestroyed(this.destroyRef$))
      .subscribe(() => {
        this.forceLogoRerender();
      });
  }

  ngAfterViewInit(): void {
    if (this.logo && this.logo.nativeElement) {
      this.originalLogoSrc = this.logo.nativeElement.src;
    }
  }

  login(): void {
    this.oidcSecurityService.authorize();
  }

  logout(): void {
    this.userService.logout();
  }

  private forceLogoRerender(): void {
    if (this.logo && this.logo.nativeElement && this.originalLogoSrc) {
      const img = this.logo.nativeElement;

      img.src = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs='; // Tiny transparent GIF
      setTimeout(() => {
        img.src = this.originalLogoSrc;
        console.log('Logo src restored to:', this.originalLogoSrc);
      }, 50); // 50ms is usually sufficient for re-paint
    }
  }
}
